import { SubscriptionsRepository } from "../repositories/SubscriptionsRepository";

export class CancelSubscriptionWithPaypal {
	constructor(private repository: SubscriptionsRepository) {}

	execute(): Promise<void> {
		return this.repository.cancelSubscriptionWithPaypal();
	}
}
